module.exports = __webpack_public_path__ + "img/i_o_my_phone.24f71864.svg";